/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Survey field-mapping type — the survey's DataHub `mapping` value. STANDARD uses BC's standard mapping (no custom profile); CUSTOM uses a vendor field mapping profile (see vendorFieldMappingProfile).
 */
export enum SurveySeasonSurveyReviewMapping {
    STANDARD = 'STANDARD',
    CUSTOM = 'CUSTOM',
}
